<template>
    <div class="ad">
      <p>【PR】</p>
      <Adsense
          data-ad-client="ca-pub-8143206471999291"
          data-ad-slot="4919886080">
      </Adsense>
    </div>
</template>

<script>
import Ads from 'vue-google-adsense'
export default {
    components:{
        Ads
    },
}
</script>

<style scoped>
.ad{
    margin:10px;
}

</style>